/**
 * @generated SignedSource<<88810262f1f959416b821f60b1c6e748>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceType = "GROUP" | "SOLO";
export type UpdateServiceInput = {
  description?: string | null;
  name?: string | null;
  placeholder?: string | null;
  type?: ServiceType | null;
};
export type ServiceEditFormMutation$variables = {
  id: string;
  input: UpdateServiceInput;
};
export type ServiceEditFormMutation$data = {
  readonly updateService: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "ServiceEditForm_service">;
  };
};
export type ServiceEditFormMutation = {
  response: ServiceEditFormMutation$data;
  variables: ServiceEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Service",
        "kind": "LinkedField",
        "name": "updateService",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ServiceEditForm_service"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Service",
        "kind": "LinkedField",
        "name": "updateService",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "placeholder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4bf404d526c060dfd1dede60c0812849",
    "id": null,
    "metadata": {},
    "name": "ServiceEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceEditFormMutation(\n  $id: ID!\n  $input: UpdateServiceInput!\n) {\n  updateService(id: $id, input: $input) {\n    ...EntitySidebar_entity\n    ...ServiceEditForm_service\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment ServiceEditForm_service on Service {\n  id\n  name\n  description\n  placeholder\n  type\n}\n"
  }
};
})();

(node as any).hash = "b0859bebb6dd6c419b8b217a7a8c315f";

export default node;
